import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import GlobalTheme from '@atlaskit/theme/components';
import { Theme } from '../theme';
import Container from './Container';
import Format from './Format';

var Badge = function Badge(_ref) {
  var theme = _ref.theme,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 0 : _ref$children,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 99 : _ref$max,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Theme.Provider, {
    value: theme
  }, /*#__PURE__*/React.createElement(GlobalTheme.Consumer, null, function (_ref2) {
    var mode = _ref2.mode;
    return /*#__PURE__*/React.createElement(Theme.Consumer, {
      appearance: appearance,
      mode: mode
    }, function (tokens) {
      return /*#__PURE__*/React.createElement(Container, _extends({}, tokens, {
        "data-testid": testId
      }), typeof children === 'string' ? children : /*#__PURE__*/React.createElement(Format, {
        max: max
      }, children));
    });
  }));
};

export default Badge;